import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router'

import Select from 'components/Select'
import SearchBar from 'components/SearchBar'

import { getAllServiceTypesNames } from 'store/Menus/selectors'
import { loadPaginatedAndFilteredRevenueCenters } from 'store/RevenueCenters/actions'
import { setQueryStringParameters } from 'store/AppState/actions'
import useDebounce from 'hooks/useDebounce'

const ListFilters = ({ queryStringParameters }) => {
  const [searchQuery, setSearchQuery] = useState(
    queryStringParameters?.searchFor
  )

  const allServiceTypes = useSelector(getAllServiceTypesNames)

  const dispatch = useDispatch()
  const history = useHistory()

  const handleChangeRevenueCentersSelect = (value) => {
    const updatedParams = {
      ...queryStringParameters,
      page: 1,
      serviceType: value,
    }

    handleLoadRevenueCenters(updatedParams)
  }

  const debouncedFetchItemsWithSearchParams = useDebounce(() => {
    const updatedParams = {
      ...queryStringParameters,
      page: 1,
      searchFor: searchQuery,
    }

    handleLoadRevenueCenters(updatedParams)
  }, 500)

  const handleLoadRevenueCenters = (params) => {
    dispatch(
      setQueryStringParameters(params, history.location.pathname)
    )
    dispatch(loadPaginatedAndFilteredRevenueCenters(params))
  }

  const handleSearch = (value) => {
    setSearchQuery(value)
    debouncedFetchItemsWithSearchParams()
  }

  const redirectToAddNew = () =>
    history.push({ state: { revenueCenterUuid: 'new' } })

  return (
    <div className="revenue-centers-filters">
      <Select
        handleChange={(value) =>
          handleChangeRevenueCentersSelect(value)
        }
        options={allServiceTypes}
        label="All Service Types"
        nameClass="-shorter"
      />
      <SearchBar
        handleSearch={handleSearch}
        searchQuery={searchQuery}
      />
      <button
        className="btn new-item"
        type="button"
        onClick={redirectToAddNew}
      >
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

export default ListFilters
